import {ParentLookupState} from './parentLookupState';

export const FoundParentSummary = ({
  parentLookup,
}: {
  parentLookup: Extract<ParentLookupState, {status: 'found'}>;
}) => {
  const name = [
    parentLookup.parentInfo.parentProfile.firstName,
    parentLookup.parentInfo.parentProfile.lastName,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      <p className="text-sm">
        <span className="font-medium">Profile</span>{' '}
        <span
          className={`badge badge-sm ${
            parentLookup.parentInfo.isParent ? 'badge-info' : 'badge-warning'
          }`}>
          {parentLookup.parentInfo.isParent ? 'Parent' : 'Teen'}
        </span>{' '}
        {name || parentLookup.parentInfo.email}
      </p>
      <p className="mt-1 text-sm">
        <span className="font-medium">User Id:</span>{' '}
        {parentLookup.parentUserId}
      </p>
      <p className="mt-1 text-sm">
        <span className="font-medium">Email:</span>{' '}
        {parentLookup.parentInfo.email}
      </p>
      <p className="mt-1 text-sm">
        <span className="font-medium">Email verified:</span>{' '}
        {parentLookup.parentInfo.emailVerified ? 'Yes' : 'No'}
      </p>
    </>
  );
};
